import './App.css';
import {useEffect, useLayoutEffect, useRef, useState} from "react";
import {
    DirectionalLight,
    Object3D,
    PerspectiveCamera,
    Scene,
    WebGLRenderer,
    AmbientLight, MeshBasicMaterial, TextureLoader, MeshStandardMaterial, MeshDepthMaterial, RepeatWrapping,
} from "three"
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader"

function App() {

    const canvasRef = useRef(null)
    const flLoader = useRef(null)
    const formAdress = useRef(null)
    const formName = useRef(null)
    const formPhone = useRef(null)

    const [sizeCasedCurrent, setSizeCasedCurrent] = useState(null)
    const [sizeCased, setSizeCased] = useState(false)
    const [modelCased, setModelCased] = useState(false)
    const [openWindow, setOpenWindow] = useState(false)
    const [openError, setOpenError] = useState(false)
    const [statusOrder, setStatusOrder] = useState(false)
    const [successOrder, setSuccessOrder] = useState(false)
    const [errorText, setErrorText] = useState("")
    const [editWall, setEditWall] = useState(-1)
    const [editSection, setEditSection] = useState(-1)
    const [sumKiosk, setSumKiosk] = useState(0)
    const [casedMatrix, setCasedMatrix] = useState([])
    const sizeArray = [["3x3",1], ["3x4.5",1], ["4.5x4.5",1], ["3x6",1]]
    const [openCanvas, setOpenCanvas]= useState(false)
    const [casedMatherial, setCasedMatherial]= useState(0)
    const [casedParam, setCasedParam] = useState([0,0,0,0])
    const [errorForm, setErrorForm] = useState([0,0,0])
    const [windowInnerWidth, setWindowInnerWidth] = useState(window.innerWidth > 768?window.innerWidth > 1024?1024:768:window.innerWidth-80)
    const [windowInnerHeight, setWindowInnerHeight] = useState(window.innerWidth > 768?window.innerWidth > 1024?650:450:450)

    //3x3       -   8 блоков    - матрица 2x2   - key 1
    //3x4.5     -   10 блоков   - матрица 2x3   - key 2
    //4.5x4.5   -   12 блоков   - матрица 3x3   - key 3
    //3x6       -   12 блоков   - матрица 2x4   - key 4

    const arrMatherial = [
        {id:0, m:"m.png", t:"Без окраски", price: 0},
        {id:1, m:"m.png", t:"Ольха", price: 2000},
        {id:2, m:"m2.png", t:"Дуб", price: 3000},
        {id:3, m:"m3.png", t:"Ясень", price: 3000},
    ]

    const arrDop = [
        {id:0, m:"m.png", t:"Обрешетка", fl:0, use:1},
        {id:1, m:"m2.png", t:"Мягкая кровля", fl:0, use:1},
        {id:2, m:"m2.png", t:"Фундамент", fl:0, use:1},
        {id:3, m:"m2.png", t:"Окрашивание", fl:0, use:0},
    ]

    const matrixKiosk = [
        [[-1,-1],[-1,-1],[-1,-1],[-1,-1],],
        [[-1,-1],[-1,-1,-1],[-1,-1],[-1,-1,-1],],
        [[-1,-1,-1],[-1,-1,-1],[-1,-1,-1],[-1,-1,-1],],
        [[-1,-1],[-1,-1,-1,-1],[-1,-1],[-1,-1,-1,-1],],
    ]
    // matrixKiosk[1] = [[8,1],[8,8,8],[8,8],[8,8,8],]
    // matrixKiosk[2] = [[1,8,8],[8,8,8],[8,8,8],[8,8,8],]

    const matrixKioskS = [
        {w:2,h:2, roof:"roof3x3", roofPrice:16000, floor: "floor3x3", floorPrice:30000, roofX:-1.5, roofY:-1.5, roofZ:1.5, floorX:-1.5, floorY:-1.5, floorZ:1.5,},
        {w:2,h:3, roof:"roof3x45", roofPrice:20000, floor: "floor3x45", floorPrice:45000, roofX:-2.25, roofY:-1.5, roofZ:1.5, floorX:-2.25, floorY:-1.5, floorZ:1.5,},
        {w:3,h:3, roof:"roof45x45", roofPrice:33000, floor: "floor45x45", floorPrice:88000, roofX:-2.151, roofY:-1.5, roofZ:2.151, floorX:-2.151, floorY:-1.5, floorZ:2.151,},
        {w:2,h:4, roof:"roof3x6", roofPrice:25000, floor: "floor3x6", floorPrice:60000, roofX:-3, roofY:-1.5, roofZ:1.5, floorX:-3, floorY:-1.5, floorZ:1.5,},
    ]
    const matrixKioskPrice = [
        {found:"foundation3x3", foundPrice:4500, tiles: "tiles3x3", tilesPrice:15000,  sheathing: "sheathing3x3", sheathingPrice:25000, fX:-1.5, fY:-1.5, fZ:1.5, tX:-1.5, tY:-1.5, tZ:1.5, sX:-1.5, sY:-1.5, sZ:1.5,},
        {found:"foundation3x45", foundPrice:6000, tiles: "tiles3x45", tilesPrice:20000,  sheathing: "sheathing3x45", sheathingPrice:28000, fX:-2.25, fY:-1.5, fZ:1.5, tX:-2.25, tY:-1.5, tZ:1.5, sX:-2.25, sY:-1.5, sZ:1.5,},
        {found:"foundation45x45", foundPrice:8000, tiles: "tiles45x45", tilesPrice:29000,  sheathing: "sheathing45x45", sheathingPrice:38000, fX:-2.151, fY:-1.5, fZ:2.151, tX:-2.151, tY:-1.5, tZ:2.151, sX:-2.151, sY:-1.5, sZ:2.151,},
        {found:"foundation3x6", foundPrice:7500, tiles: "tiles3x6", tilesPrice:26000,  sheathing: "sheathing3x6", sheathingPrice:35000, fX:-3, fY:-1.5, fZ:1.5, tX:-3, tY:-1.5, tZ:1.5, sX:-3, sY:-1.5, sZ:1.5,},
    ]

    const matrix3d3x3 = [
        [{x:-1.422,y:-1.38,z:-1.412,r:-Math.PI / 2},{x:0.02,y:-1.38,z:-1.412,r:-Math.PI / 2},], //up
        [{x:-1.458,y:-1.38,z:0.02,r:0},{x:-1.458,y:-1.38,z:1.454,r:0},], // left
        [{x:0.02,y:-1.38,z:1.454,r:Math.PI / 2},{x:1.454,y:-1.38,z:1.454,r:Math.PI / 2},], //down
        [{x:1.5,y:-1.38,z:-1.420,r:Math.PI},{x:1.5,y:-1.38,z:0.02,r:Math.PI},], //right
    ]
    const matrix3d3x45 = [
        [{x:2.20,y:-1.38,z:-1.420,r:Math.PI},{x:2.20,y:-1.38,z:0.02,r:Math.PI},], //up
        [{x:0.703,y:-1.38,z:-1.42,r:-Math.PI / 2},{x:-0.731,y:-1.38,z:-1.42,r:-Math.PI / 2},{x:-2.165,y:-1.38,z:-1.42,r:-Math.PI / 2},],//left
        [{x:-2.20,y:-1.38,z:0.02,r:0},{x:-2.20,y:-1.38,z:1.444,r:0},], //down
        [{x:2.137,y:-1.38,z:1.45,r:Math.PI / 2},{x:0.703,y:-1.38,z:1.45,r:Math.PI / 2},{x:-0.731,y:-1.38,z:1.45,r:Math.PI / 2},],// right
    ]
    const matrix3d45x45 = [
        [{x:2.238,y:-1.38,z:2.151,r:Math.PI / 2},{x:0.804,y:-1.38,z:2.151,r:Math.PI / 2},{x:-0.63,y:-1.38,z:2.151,r:Math.PI / 2},], //up
        [{x:2.284,y:-1.38,z:0.670,r:Math.PI},{x:2.284,y:-1.38,z:-0.764,r:Math.PI},{x:2.284,y:-1.38,z:-2.198,r:Math.PI},], //left
        [{x:0.804,y:-1.38,z:-2.2,r:-Math.PI / 2},{x:-0.63,y:-1.38,z:-2.2,r:-Math.PI / 2},{x:-2.064,y:-1.38,z:-2.2,r:-Math.PI / 2},], //down
        [{x:-2.111,y:-1.38,z:2.104,r:0},{x:-2.111,y:-1.38,z:0.67,r:0},{x:-2.111,y:-1.38,z:-0.764,r:0},], // right
    ]
    const matrix3d3x6 = [
        [{x:-2.96,y:-1.38,z:1.44,r:0},{x:-2.96,y:-1.38,z:0.02,r:0},], //up
        [{x:-1.474,y:-1.38,z:1.46,r:Math.PI / 2},{x:-0.04,y:-1.38,z:1.46,r:Math.PI / 2},{x:1.39,y:-1.38,z:1.46,r:Math.PI / 2},{x:2.82,y:-1.38,z:1.46,r:Math.PI / 2},], // left
        [{x:2.88,y:-1.38,z:0.02,r:-Math.PI},{x:2.88,y:-1.38,z:-1.42,r:-Math.PI},], //down
        [{x:-2.92,y:-1.38,z:-1.42,r:-Math.PI / 2},{x:-1.48,y:-1.38,z:-1.42,r:-Math.PI / 2},{x:-0.04,y:-1.38,z:-1.42,r:-Math.PI / 2},{x:1.394,y:-1.38,z:-1.42,r:-Math.PI / 2},], // right
    ]
    const matrixForm = [
        matrix3d3x3,
        matrix3d3x45,
        matrix3d45x45,
        matrix3d3x6,
    ]

    const arrayWalls = [
        {id:1, name:"Финляндия 2", article: "C1", img:"03.jpg", price:5200, obj:"c1"},
        {id:2, name:"Япония - Вход", article: "C2", img:"11.jpg", price:3000, obj:"c2"},
        {id:3, name:"Финляндия 3", article: "C3", img:"02.jpg", price:7500, obj:"c3"},
        {id:4, name:"Симфония 1", article: "C4", img:"09.jpg", price:5500, obj:"c4"},
        {id:5, name:"Финляндия 1", article: "C5", img:"10.jpg", price:8000, obj:"c5"},
        {id:6, name:"Озера 2", article: "C6", img:"08.jpg", price:4500, obj:"c6"},
        {id:7, name:"Озера 1", article: "C7", img:"06.jpg", price:4500, obj:"c7"},
        {id:8, name:"Симфония 3", article: "C8", img:"07.jpg", price:5900, obj:"c8"},
        {id:9, name:"Япония 3", article: "C9", img:"01.jpg", price:7000, obj:"c9"},
        {id:10, name:"Симфония 4", article: "C10", img:"05.jpg", price:4500, obj:"c10"},
    ]


    const changedSizeCurrent = (e) => {
        setSizeCasedCurrent(Number(e.currentTarget.value));
    }
    const changedSize = () => {
        if (sizeCasedCurrent === null) {
            return
        }
        setCasedMatrix(matrixKiosk[sizeCasedCurrent])
        setSizeCased(true);
    }
    const changeSection = (e) => {
        setEditWall(Number(e.currentTarget.getAttribute("wall")));
        setEditSection(Number(e.currentTarget.getAttribute("section")));
        setOpenWindow(true);
    }

    const caseSectionWall = (e) => {
        casedMatrix[editWall][editSection] = e.currentTarget.getAttribute("sectionwall");
        setCasedMatrix([...casedMatrix])
        setOpenWindow(false);
    }

    const countPrice = () => {
        if (!sizeCased) {
            return;
        }

        let fl = false
        let sum = 0;
        for (let i = 0; i < casedMatrix.length; i++) {
            for (let j = 0; j < casedMatrix[i].length; j++) {
                if (Number(casedMatrix[i][j]) === -1) {
                    setErrorText("Вы заполнили не все стены");
                    setOpenError(true);
                    return
                }
                if (Number(casedMatrix[i][j]) === 1) {
                    fl=true;
                }
                sum = sum + arrayWalls[casedMatrix[i][j]].price
            }
        }
        if (fl === false) {
            setErrorText("У Вас нет ни одной двери");
            setOpenError(true);
            return;
        }

        sum = sum + matrixKioskS[sizeCasedCurrent].floorPrice + matrixKioskS[sizeCasedCurrent].roofPrice

        for (let i = casedParam.length - 1; i >= 0; i--) {
            if (casedParam[i] === 1) {
                if (i===3) {
                    //плюсуем окрашивание
                    sum = sum + arrMatherial[casedMatherial].price
                }
                if (i===2) {
                    //плюсуем фундамент
                    sum = sum + matrixKioskPrice[sizeCasedCurrent].foundPrice
                }
                if (i===1) {
                    //плюсуем кровлю + обрешетку
                    sum = sum + matrixKioskPrice[sizeCasedCurrent].tilesPrice + matrixKioskPrice[sizeCasedCurrent].sheathingPrice
                    break;
                }
                if (i===0) {
                    //плюсуем обрешетку
                    sum = sum + matrixKioskPrice[sizeCasedCurrent].sheathingPrice
                }
            }
        }

        setSumKiosk(sum)
        setOpenCanvas(true)
        setModelCased(true)
    }

    useEffect(() => {
        countPrice()
    }, [casedParam])
    const modify = () => {
        setModelCased(false)
        setOpenCanvas(false)
        setSumKiosk(0)
    }
    const order = () => {
        setStatusOrder(true)
    }
    const cancelOrder = () => {
        setStatusOrder(false)

    }

    const closeModal = () => {
        setOpenError(false)
        setErrorText("")
        setOpenWindow(false)
    }
    const setMatherials = (e) => {
        setCasedMatherial(Number(e.currentTarget.getAttribute("matherial")));
    }
    const setDopParam = (e) => {
        if (casedParam[Number(e.currentTarget.getAttribute("param"))] === 0 ) {
            // param = 1
            casedParam[Number(e.currentTarget.getAttribute("param"))] = 1
        } else {
            casedParam[Number(e.currentTarget.getAttribute("param"))] = 0
            // param = 0
        }
        if (Number(e.currentTarget.getAttribute("param")) === 1 && casedParam[Number(e.currentTarget.getAttribute("param"))] === 1) {
            casedParam[0] = casedParam[Number(e.currentTarget.getAttribute("param"))]
        }
        if (Number(e.currentTarget.getAttribute("param")) === 0 && casedParam[Number(e.currentTarget.getAttribute("param"))] === 0) {
            casedParam[1] = casedParam[Number(e.currentTarget.getAttribute("param"))]
        }
        if (Number(e.currentTarget.getAttribute("param")) === 3 && casedParam[Number(e.currentTarget.getAttribute("param"))] === 0) {
            setCasedMatherial(0)
        }

        setCasedParam([...casedParam])
    }
    const resetState = () => {
        setSizeCasedCurrent(null);
        setSizeCased(false);
        setOpenWindow(false);
        setEditSection(-1);
        setEditWall(-1);
        setCasedMatrix([])
        setSumKiosk(0)
        setOpenCanvas(false)
        setModelCased(false)
        setCasedParam([0,0,0,0])
        setSuccessOrder(false);
    }
    const foundTexture = new TextureLoader().load("/wp-content/uploads/calc4/found.png")
    foundTexture.wrapS = RepeatWrapping;
    foundTexture.wrapT = RepeatWrapping;
    const foundMaterail = new MeshStandardMaterial({map: foundTexture})
    const tilesTexture = new TextureLoader().load("/wp-content/uploads/calc4/tiles.png")
    tilesTexture.wrapS = RepeatWrapping;
    tilesTexture.wrapT = RepeatWrapping;
    const tilesMaterail = new MeshStandardMaterial({map: tilesTexture})

    const scene = new Scene()
    // lights
    const directionalLight = new DirectionalLight(0xe8e8e8, 1)
    directionalLight.position.set(-10, -1, 0)
    directionalLight.lookAt(0, 0, 0)
    scene.add(directionalLight)
    const directionalLight2 = new DirectionalLight(0xe8e8e8, 1)
    directionalLight2.position.set(10, -1, 0)
    directionalLight2.lookAt(0, 0, 0)
    scene.add(directionalLight2)
    const directionalLight3 = new DirectionalLight(0xe8e8e8, 1)
    directionalLight3.position.set(0, -1, 10)
    directionalLight3.lookAt(0, 0, 0)
    scene.add(directionalLight3)
    const directionalLight4 = new DirectionalLight(0xe8e8e8, 1)
    directionalLight4.position.set(0, -1, -10)
    directionalLight4.lookAt(0, 0, 0)
    scene.add(directionalLight4)
    const directionalLight5 = new DirectionalLight(0xe8e8e8, 1)
    directionalLight5.position.set(0, 1, 0)
    directionalLight5.lookAt(0, 0, 0)
    scene.add(directionalLight5)

    useLayoutEffect(() => {

        if (openCanvas) {

            const renderer = new WebGLRenderer({
                canvas: canvasRef.current,
                antialias: true,
                alpha: true,
                premultipliedAlpha: true,
            })


            const texture = new TextureLoader().load("/wp-content/uploads/calc4/"+arrMatherial[casedMatherial].m)
            texture.wrapS = RepeatWrapping;
            texture.wrapT = RepeatWrapping;
            const materail = new MeshStandardMaterial({map: texture})


            // console.log(window.innerWidth)
            // if (window.innerWidth > 768) {
            //     setWindowInnerWidth(768)
            //     setWindowInnerHeight(450)
            // } else {
            //     setWindowInnerWidth(window.innerWidth-80)
            //     setWindowInnerHeight(450)
            // }

            const camera = new PerspectiveCamera(
                75, // fov
                windowInnerWidth / windowInnerHeight, // aspect
                0.1, // near
                100 // far
            )

            camera.position.set(6, 0.75, 0)


            // const directionalLight6 = new DirectionalLight(0xffffff, 1)
            // directionalLight6.position.set(0, 0, 0)
            // directionalLight6.lookAt(0, -10, 0)
            // scene.add(directionalLight6)

            const ambientLight = new AmbientLight(0xffffff, 1)
            scene.add(ambientLight)

            //fbx model
            const container = new Object3D()
            container.position.set(0, 0, 0)

            const fbxLoader = new FBXLoader()

            fbxLoader.load(
                "/wp-content/uploads/calc4/"+matrixKioskS[sizeCasedCurrent].floor+".fbx",
                (object) => {
                    object.scale.set(1, 1, 1)
                    object.position.set(matrixKioskS[sizeCasedCurrent].floorX, matrixKioskS[sizeCasedCurrent].floorY, matrixKioskS[sizeCasedCurrent].floorZ)
                    object.traverse(function (child) {
                        if (child.isMesh) {
                            child.material = materail;
                        }
                    })
                    container.add(object)
                },
                (xhr) => {
                    // console.log((xhr.loaded / xhr.total) * 100 + "% loaded")
                },
                (error) => {
                    // console.log(error)
                }
            )
            fbxLoader.load(
                "/wp-content/uploads/calc4/"+matrixKioskS[sizeCasedCurrent].roof+".fbx",
                (object) => {
                    object.scale.set(1, 1, 1)
                    object.position.set(matrixKioskS[sizeCasedCurrent].roofX, matrixKioskS[sizeCasedCurrent].roofY, matrixKioskS[sizeCasedCurrent].roofZ)
                    object.traverse(function (child) {
                        if (child.isMesh) {
                            child.material = materail;
                        }
                    })
                    container.add(object)
                },
                (xhr) => {
                    // console.log((xhr.loaded / xhr.total) * 100 + "% loaded")
                },
                (error) => {
                    // console.log(error)
                }

            )

            for (let i = casedParam.length - 1; i >= 0; i--) {
                if (casedParam[i] === 1) {
                    if (i===3) {
                        //плюсуем окрашивание
                    }
                    if (i===2) {
                        //плюсуем фундамент
                        fbxLoader.load(
                            "/wp-content/uploads/calc4/"+matrixKioskPrice[sizeCasedCurrent].found+".fbx",
                            (object) => {
                                object.scale.set(1, 1, 1)
                                object.position.set(matrixKioskPrice[sizeCasedCurrent].fX, matrixKioskPrice[sizeCasedCurrent].fY, matrixKioskPrice[sizeCasedCurrent].fZ)
                                object.traverse(function (child) {
                                    if (child.isMesh) {
                                        child.material = foundMaterail;
                                    }
                                })
                                container.add(object)
                            },
                            (xhr) => {
                                // console.log((xhr.loaded / xhr.total) * 100 + "% loaded")
                            },
                            (error) => {
                                // console.log(error)
                            }
                        )
                    }
                    if (i===1) {
                        //плюсуем кровлю + обрешетку
                        fbxLoader.load(
                            "/wp-content/uploads/calc4/"+matrixKioskPrice[sizeCasedCurrent].tiles+".fbx",
                            (object) => {
                                object.scale.set(1, 1, 1)
                                object.position.set(matrixKioskPrice[sizeCasedCurrent].tX, matrixKioskPrice[sizeCasedCurrent].tY, matrixKioskPrice[sizeCasedCurrent].tZ)
                                object.traverse(function (child) {
                                    if (child.isMesh) {
                                        child.material = tilesMaterail;
                                    }
                                })
                                container.add(object)
                            },
                            (xhr) => {
                                // console.log((xhr.loaded / xhr.total) * 100 + "% loaded")
                            },
                            (error) => {
                                // console.log(error)
                            }
                        )
                        fbxLoader.load(
                            "/wp-content/uploads/calc4/"+matrixKioskPrice[sizeCasedCurrent].sheathing+".fbx",
                            (object) => {
                                object.scale.set(1, 1, 1)
                                object.position.set(matrixKioskPrice[sizeCasedCurrent].sX, matrixKioskPrice[sizeCasedCurrent].sY, matrixKioskPrice[sizeCasedCurrent].sZ)
                                object.traverse(function (child) {
                                    if (child.isMesh) {
                                        child.material = materail;
                                    }
                                })
                                container.add(object)
                            },
                            (xhr) => {
                                // console.log((xhr.loaded / xhr.total) * 100 + "% loaded")
                            },
                            (error) => {
                                // console.log(error)
                            }
                        )
                        break;
                    }
                    if (i===0) {
                        //плюсуем обрешетку
                        fbxLoader.load(
                            "/wp-content/uploads/calc4/"+matrixKioskPrice[sizeCasedCurrent].sheathing+".fbx",
                            (object) => {
                                object.scale.set(1, 1, 1)
                                object.position.set(matrixKioskPrice[sizeCasedCurrent].sX, matrixKioskPrice[sizeCasedCurrent].sY, matrixKioskPrice[sizeCasedCurrent].sZ)
                                object.traverse(function (child) {
                                    if (child.isMesh) {
                                        child.material = materail;
                                    }
                                })
                                container.add(object)
                            },
                            (xhr) => {
                                // console.log((xhr.loaded / xhr.total) * 100 + "% loaded")
                            },
                            (error) => {
                                // console.log(error)
                            }
                        )
                    }
                }
            }

            for (let i = 0; i < casedMatrix.length; i++) {
                for (let j = 0; j < casedMatrix[i].length; j++) {
                    fbxLoader.load(
                        "/wp-content/uploads/calc4/"+arrayWalls[casedMatrix[i][j]].obj+".fbx",
                        (object) => {
                            object.scale.set(1, 1, 1)
                            object.position.set(matrixForm[sizeCasedCurrent][i][j].x, matrixForm[sizeCasedCurrent][i][j].y, matrixForm[sizeCasedCurrent][i][j].z)
                            object.rotateY(matrixForm[sizeCasedCurrent][i][j].r)
                            object.traverse(function (child) {
                                if (child.isMesh) {
                                    child.material = materail;
                                }
                            })
                            container.add(object)

                        },
                        (xhr) => {
                            // console.log((xhr.loaded / xhr.total) * 100 + "% loaded")
                        },
                        (error) => {
                            // console.log(error)
                        }
                    )

                }
            }

            scene.add(container)

            renderer.setAnimationLoop(() => {
                //container.rotation.y -= 0.01
                renderer.render(scene, camera)
            })
            renderer.setSize(windowInnerWidth, windowInnerHeight)

            const onResize = () => {
                if (window.innerWidth >= 768) {
                    setWindowInnerWidth(768)
                    setWindowInnerHeight(450)
                } else {
                    setWindowInnerWidth(window.innerWidth-80)
                    setWindowInnerHeight(450)
                }
                camera.aspect = windowInnerWidth / windowInnerHeight
                camera.updateProjectionMatrix()
                renderer.setSize(windowInnerWidth, windowInnerHeight)
            }

            window.addEventListener("resize", onResize, false)

            new OrbitControls(camera, renderer.domElement)

            return () => {
                window.removeEventListener("resize", onResize)
            }
        }

    }, [openCanvas, casedMatrix, casedMatherial, casedParam])

    useEffect(()=>{
        if (openCanvas) {
            flLoader.current.scrollIntoView({behavior: 'smooth'})
        }
    },[openCanvas])

    const [formData, setFormData] = useState({
        name: '',
        // email: '',
        phone: '',
        // message: '',
        adress: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const ValidPhone = (myPhone) => {
        let re = /^[\d\+][\d\(\)\ -]{4,14}\d$/;
        let valid = re.test(myPhone);
        if (valid) {
            return true
        } else {
            return false
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        let haveErrorForm = false
        if (formName.current.value === "") {
            errorForm[0]=1
            setErrorForm([...errorForm])
            haveErrorForm=true
        } else {
            errorForm[0]=0
            setErrorForm([...errorForm])
        }
        if (!ValidPhone(formPhone.current.value)) {
            errorForm[1]=1
            setErrorForm([...errorForm])
            haveErrorForm=true
        } else {
            errorForm[1]=0
            setErrorForm([...errorForm])
        }
        if (formAdress.current.value === "") {
            errorForm[2]=1
            setErrorForm([...errorForm])
            haveErrorForm=true
        } else {
            errorForm[2]=0
            setErrorForm([...errorForm])
        }
        if (haveErrorForm) {
            return
        }

        let _formData = formData
        _formData.alcove = sizeArray[sizeCasedCurrent][0];
        _formData.price = sumKiosk;
        let wall = ""
        for (let i = 0; i < casedMatrix.length; i++) {
            let g = ""
            if (i === 0) {
                g = "верхняя"
            } else if (i === 1) {
                g = "левая"
            } else if (i === 2) {
                g = "нижняя"
            } else if (i === 3) {
                g = "правая"
            }
            wall = wall+`Стена ` + g + `:\n`
            for (let j = 0; j < casedMatrix[i].length; j++) {
                wall = wall+"Секция: "+(j+1)+": "+arrayWalls[casedMatrix[i][j]].name + " (" + arrayWalls[casedMatrix[i][j]].article+ ") | Цена: " + (arrayWalls[casedMatrix[i][j]].price).toLocaleString('ru')+` руб.\n`;
            }
            wall = wall+`\n`
        }
        _formData.sheathing = "Да"
        if (casedParam[0] === 0) {
            _formData.sheathing = "Нет"
        }
        _formData.tiles = "Да"
        if (casedParam[1] === 0) {
            _formData.tiles = "Нет"
        }
        _formData.foundation = "Да"
        if (casedParam[2] === 0) {
            _formData.foundation = "Нет"
        }
        _formData.wall = wall

        try {
            const csrfResponse = await fetch('https://leader-house.ru/get-csrf-token.php');
            const { csrf_token } = await csrfResponse.json();

            const response = await fetch('https://leader-house.ru/plf.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrf_token,
                },
                body: JSON.stringify({..._formData, ...formData}),
                credentials: 'include',
            });

            const result = await response.json();
            if (result.success) {
                setSuccessOrder(true);
            }


            setFormData({
                name: '',
                // email: '',
                phone: '',
                // message: '',
                adress: '',
            });
        } catch (error) {
            console.error('Error sending feedback:', error);
        }
    };



    return (
        <div className="App">
            <header className="App-header">
                <img src={"/wp-content/themes/leader/img/logo-header.png"} className={"logo"}></img>
                <h1>Конструктор модульной беседки</h1>
                {sizeCased?
                <div onClick={resetState} className={"btn btn-undo"}>Выбрать другой размер</div>
                    :null}
            </header>
            {!sizeCased?
                <div className={"conteiner"}>
                    <h2>Выберите размер</h2>
                    {sizeArray.map((v,i)=>(
                    <div key={i} className={"wrapperRadioSize"}>
                        <input type="radio" className={"radioSize"} value={i} disabled={v[1]===0?"disabled":""} name={"size"} id={"size"+i} onChange={changedSizeCurrent}/>
                        <label htmlFor={"size"+i} className={"labelRadioSize"} >{v[0]}{v[1]===0?" - в разработке":""}</label>
                    </div>
                    ))}
                    <div onClick={changedSize} className={"btn btn-next"}>Далее</div>
                </div>
                :!modelCased?<div className={"dashboard width-"+matrixKioskS[sizeCasedCurrent].w+" dashboard-"+sizeCasedCurrent+" height-"+matrixKioskS[sizeCasedCurrent].h}>
                    {matrixKiosk[sizeCasedCurrent].map((wall,wall_i)=>(
                        <div key={wall_i} className={"wall wall_"+wall_i}>
                            {wall.map((section, section_i)=>(
                                    <div key={section_i} className={casedMatrix[wall_i][section_i]>-1?"sectionWall sectionWall_"+wall_i+" active":"sectionWall sectionWall_"+wall_i} wall={wall_i} section={section_i} onClick={changeSection}>
                                        {casedMatrix[wall_i][section_i]>-1?
                                                <img src={process.env.PUBLIC_URL +"/wp-content/uploads/calc4/"+arrayWalls[Number(casedMatrix[wall_i][section_i])].img} />
                                            :<img src={process.env.PUBLIC_URL +"/wp-content/uploads/calc4/00.jpg"} />
                                        }</div>))}
                        </div>
                    ))}
                    <footer className="App-header">
                        <div onClick={countPrice} className={"btn"}>Рассчитать стоимость</div>
                    </footer>
                </div>:null}

            {openWindow?(
                <div className={"modal-window"} onClick={closeModal}>
                    <div className={"dashboard-modal-window"}>
                        {arrayWalls.map((el,i) => (
                            <div key={i} className={"card-section"} sectionwall={i} onClick={caseSectionWall}>
                                <img className={"img-wall"} src={process.env.PUBLIC_URL +"/wp-content/uploads/calc4/"+el.img} />
                                <div className={"name-wall"}>{el.name}</div>
                                <div className={"article-wall"}>{"Артикл: "+el.article}</div>
                                <div className={"price-wall"}>{"Цена: "+(el.price).toLocaleString('ru')+" руб."}</div>
                                <div className={"bg-wall"}></div>
                            </div>
                        ))}
                    </div>
                </div>
            ):null}
            {openError?(
                <div className={"modal-window"} onClick={closeModal}>
                    <div className={"dashboard-modal-error"}>
                        {errorText}
                    </div>
                </div>
            ):null}
            {openCanvas>0?(
            <div className={"conteiner-canvas"}>
                <div className={"doptools-dashboard"}>
                    <div className={"dop-dashboard"}>
                        {arrDop.map((param,param_i)=>(
                            param.use === 1?
                            <div key={param_i} className={casedParam[param_i]===1?"dop-item active":"dop-item"} param={param.id} onClick={setDopParam}>
                                {/*<img src={"/wp-content/uploads/calc4/"+param.m}/>*/}
                                <span>{param.t}</span>
                            </div>:null
                        ))}
                    </div>
                </div>
                {casedParam[3]===1?(
                <div className={"tools-dashboard"}>
                    <div className={"color-dashboard"}>
                        {arrMatherial.map((color,color_i)=>(
                            <div key={color_i} className={"color-item"} matherial={color_i} onClick={setMatherials}>
                                <img src={"/wp-content/uploads/calc4/"+color.m}/>
                                <span>{color.t}</span>
                            </div>
                        ))}
                    </div>
                </div>):null}
                <canvas ref={canvasRef}/>
                {sumKiosk>0?(
                    <div className={"price-kiosk"} >
                        <div className={"full-price"}>Расчетная цена: <span className={"full-price-count"}>{(sumKiosk).toLocaleString('ru')}</span>  руб.</div>
                        <div onClick={modify} className={"btn btn-counter"}>Внести изменения</div>
                        <div onClick={order} className={"btn btn-order"}>Оформить заказ</div>

                    </div>
                ):null}
            </div>
                ):null}
            {statusOrder?(
                <div className={"order-window"} >
                    <form onSubmit={handleSubmit} className={"form-order"}>
                        {successOrder?(
                            <div className={"success-form-block"}>
                                <div className={"success-form-header"}>Заказ сформирован</div>
                                <div className={"success-form-text"}>С Вами свяжутся в ближайшее время</div>
                            </div>
                        ):(
                            <div className={"success-form-block"}>
                                <div className={"success-form-header"}>Форма заказа</div>
                            </div>
                        )}
                        {!successOrder?(<label className={errorForm[0]===1?"form-error":null}>
                            Ваше имя:{errorForm[0]===1?<span className={"form-error"}>*</span>:null}
                            <input type="text" name="name" value={formData.name} onChange={handleChange} ref={formName}/>
                        </label>):null}
                        <br />
                        {!successOrder?(<label className={errorForm[1]===1?"form-error":null}>
                            Ваш телефон: {errorForm[1]===1?<span className={"form-error"}>*</span>:null}
                            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} ref={formPhone} />
                        </label>):null}
                        {/*<br />*/}
                        {/*<label>*/}
                        {/*    Ваш email:*/}
                        {/*    <input type="email" name="email" value={formData.email} onChange={handleChange} />*/}
                        {/*</label>*/}
                        <br />
                        {!successOrder?(<label className={errorForm[2]===1?"form-error":null}>
                            Адрес доставки: {errorForm[2]===1?<span className={"form-error"}>*</span>:null}
                            <input type="adress" name="adress" value={formData.adress} onChange={handleChange}  ref={formAdress}/>
                        </label>):null}
                        <br />
                        <div className={"btn btn-undo"} onClick={cancelOrder}>{successOrder?"Закрыть":"Отмена"}</div>
                        {successOrder?null:(<button className={"btn btn-create-order"} type="submit">Заказать</button>)}
                    </form>
                </div>
            ):null}

            <div className={"fl-loader"} ref={flLoader}></div>
        </div>
    );
}

export default App;
